// import React, { useEffect } from "react";
// import { Fancybox } from "@fancyapps/ui";
// import "@fancyapps/ui/dist/fancybox/fancybox.css";

// const View = () => {
//     useEffect(() => {
//         // Bind Fancybox to elements with data-fancybox attribute
//         Fancybox.bind("[data-fancybox='gallery']", {});

//         return () => {
//             Fancybox.destroy(); // cleanup on unmount
//         };
//     }, []);

//     return (
//         <div className="p-6">
//             <a href="/images/large1.jpg" data-fancybox="gallery">
//                 <img
//                     src="/images/thumb1.jpg"
//                     alt="Thumbnail 1"
//                     className="w-40 h-40 object-cover rounded-lg shadow-md cursor-pointer"
//                 />
//             </a>

//             <a href="/images/large2.jpg" data-fancybox="gallery" className="ml-4">
//                 <img
//                     src="/images/thumb2.jpg"
//                     alt="Thumbnail 2"
//                     className="w-40 h-40 object-cover rounded-lg shadow-md cursor-pointer"
//                 />
//             </a>
//         </div>
//     );
// };

// export default View;







import { useState, useEffect, useRef } from "react";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import styles from "./style.module.css";
import { Link } from "react-router-dom";

export default function View({ slides, autoPlay = false, interval = 5000 }) {
    const [currentPosition, setCurrentPosition] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [offset, setOffset] = useState(0);
    const sliderRef = useRef(null);
    const draggingPreventClick = useRef(false);

    // Auto-play
    useEffect(() => {
        if (!autoPlay || isDragging) return;
        const timer = setInterval(() => {
            nextSlide();
        }, interval);
        return () => clearInterval(timer);
    }, [currentPosition, autoPlay, interval, isDragging]);

    const nextSlide = () => {
        setCurrentPosition((prev) => (prev === slides.length - 1 ? slides.length - 1 : prev + 1));
        setOffset(0);
    };

    const prevSlide = () => {
        setCurrentPosition((prev) => (prev === 0 ? 0 : prev - 1));
        setOffset(0);
    };

    // Mouse/Touch Handlers
    const handleStart = (e) => {
        setIsDragging(true);
        setStartX(e.type.includes("mouse") ? e.pageX : e.touches[0].pageX);
        draggingPreventClick.current = false; // reset at start
    };

    const handleMove = (e) => {
        if (!isDragging) return;
        const x = e.type.includes("mouse") ? e.pageX : e.touches[0].pageX;
        const diff = x - startX;
        setOffset(diff);
        if (Math.abs(diff) > 5) {
            draggingPreventClick.current = true; // mark as drag
        }
    };

    const handleEnd = () => {
        if (!isDragging) return;
        setIsDragging(false);

        // Threshold for slide change
        if (offset > 100) {
            prevSlide();
        } else if (offset < -100) {
            nextSlide();
        } else {
            setOffset(0); // reset
        }
    };

    useEffect(() => {
        // Bind Fancybox to elements with data-fancybox attribute
        Fancybox.bind("[data-fancybox='gallery']", {});

        return () => {
            Fancybox.destroy(); // cleanup on unmount
        };
    }, []);

    const handleClickCapture = (e) => {
        if (draggingPreventClick.current) {
            e.preventDefault(); // stop navigation
            e.stopPropagation();
        }
    };

    return (
        <div
            className={styles.sliderContainer}
            ref={sliderRef}
            onMouseDown={handleStart}
            onMouseMove={handleMove}
            onMouseUp={handleEnd}
            onMouseLeave={handleEnd}
            onTouchStart={handleStart}
            onTouchMove={handleMove}
            onTouchEnd={handleEnd}
        >
            {/* Slides */}
            <div
                className={styles.parentView}
                style={{
                    transform: `translateX(calc(-${currentPosition * 100}% + ${offset}px))`,
                    transition: isDragging ? "none" : "transform 0.7s ease-in-out",
                }}
            >
                {slides.map((slide, index) => (
                    <Link key={'slide_' + index} to={slide} className={styles.item} data-fancybox="gallery" onClickCapture={handleClickCapture}>
                        <div
                            className={styles.item}
                            style={{
                                backgroundImage: slide ? `url(${slide})` : undefined,
                            }}
                        >
                        </div>
                    </Link>
                ))}
            </div>

            <div className={styles.controllerView}>
                <div className={styles.indicator}>
                    {slides.map((_, index) => (
                        <button
                            key={index}
                            onClick={() => setCurrentPosition(index)}
                            className={`${styles.bullet} ${currentPosition === index ? styles.active : ""}`}
                        />
                    ))}
                </div>

                <div className={styles.buttons}>
                    <button className={`${styles.button} ${styles.prev}`} onClick={prevSlide} disabled={currentPosition === 0}>
                        <span className="material-symbols-outlined">arrow_back_ios_new</span>
                    </button>
                    <button className={`${styles.button} ${styles.next}`} onClick={nextSlide} disabled={currentPosition === 2}>
                        <span className="material-symbols-outlined">arrow_forward_ios</span>
                    </button>
                </div>
            </div>
        </div>
    );
}